import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { CarouselService } from 'src/app/services/panels/carousel.service';
import { Cgimgs } from 'src/app/interfaces/cgimgs';
import { Subscription } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminAccessService } from 'src/app/services/admin-access.service';
import { Access } from 'src/app/interfaces/access';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-add-carousel',
  templateUrl: './add-carousel.component.html',
  styleUrls: ['./add-carousel.component.scss']
})
export class AddCarouselComponent implements OnInit,OnDestroy {

  carousel: Cgimgs[] =[]

  carouselObservable:Subscription;

  access: Access[] =[]


  constructor(private Carousel:CarouselService,
    private fs:AngularFirestore,
    private storage: AngularFireStorage,
    private getaccess:AdminAccessService,
    private router:Router,
    private auth:AuthService) { }

  ngOnInit(): void {
    this.carouselObservable = this.Carousel.getCarouselWId().subscribe(data => {
      this.carousel = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
    })

    this.getaccess.getAccess().subscribe(data=> {
      this.access = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
    })

  }

  @ViewChild('photoUrl') photoUrl:ElementRef;
 
  loading:boolean=false

  done:boolean=false

  addCarouselS:boolean=true

  methods = 'Center Right Left'.split(' ');

  selectedmethod = this.methods[1];

  direction: string = '';


  onChange(newMethod) {
    this.selectedmethod = newMethod;
    this.direction = newMethod;
  }

   addCarousel(f1:NgForm) {
    this.loading = true
    this.addCarouselS = false
    let title = (<Cgimgs>f1.value).title,
        title_ar = (<Cgimgs>f1.value).title_ar,
        description = (<Cgimgs>f1.value).description,
        description_ar = (<Cgimgs>f1.value).description_ar,
        photoUrl = (<HTMLInputElement>this.photoUrl.nativeElement).files[0];
        
        this.Carousel.addCarousel(this.direction,title,title_ar,description,description_ar,photoUrl)
     .then(()=> {
      this.loading = false
      this.done = true
      setTimeout(() => {
        this.done = false
        this.addCarouselS = true
      }, 4000);
     })    
   }

  editCarouselS:boolean=false

  onFocus() {
    this.editCarouselS = true
  }

  editCarousel(id:string,title:string,title_ar:string,description:string,description_ar:string) {
    this.loading = true
    this.editCarouselS = false
        
    this.fs.doc(`carousel/${id}`).update({
        title,
        title_ar,
        description,
        description_ar,
      })
      .then(()=>{
        this.loading = false
        this.done = true
        setTimeout(() => {
          this.done = false
        }, 4000);
      })
  }
  
  // @ViewChild('updatephotoUrl') updatephotoUrl:ElementRef;

  // PhotoUpdated:boolean = false

  // PhotoUpdateds:boolean = false

  // changePhotoLoading:boolean = false

  // onFocus_PhotoUpdateds() {
  //   this.PhotoUpdateds = true
  // }

  // updatePhoto(id1:string){
  //   this.changePhotoLoading = true
  //   this.PhotoUpdateds = false
  //   let photoUrl = (<HTMLInputElement>this.updatephotoUrl.nativeElement).files[0],
  //     ref = this.storage.ref('carousel/' + photoUrl.name);
  //     ref.put(photoUrl).then(()=> {
  //       ref.getDownloadURL().subscribe(photoUrl => {
  //         this.fs.doc(`carousel/${id1}`).update({
  //           photoUrl
  //         })
  //       })
  //     })
  //     .then(()=>{
  //       this.PhotoUpdated = true
  //       this.changePhotoLoading = false
  //       setTimeout(() => {
  //         this.PhotoUpdated = false
  //         this.PhotoUpdateds = true
  //       }, 4000);
  //     })
  // }

  deleteItem(id:string) {
    this.fs.doc(`carousel/${id}`).delete()
    .then(()=> {
      alert('deleted')
    })
  }

  ngOnDestroy() {
    this.carouselObservable.unsubscribe();
  }

  deleteAccess(){
    // this.fs.doc(`admins/${id}`).delete()
    this.auth.logout().then(()=>{
      this.router.navigate(['/controls-panel-login'])
    })
  }
}
